import { render, staticRenderFns } from "./StationPhotos.vue?vue&type=template&id=2673ce16"
import script from "./StationPhotos.vue?vue&type=script&lang=js"
export * from "./StationPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports